<section class="select-list">
  <div
    class="top-header tw-px-1"
    [class.d-none]="isReadOnly"
    [ngClass]="isFixedSearchBox ? 'tw-pl-2 tw-px-4' : ''"
    [style]="isFixedSearchBox ? 'position:sticky;bottom:0;' : ''"
  >
    <ng-container *ngIf="isRequired">
      <p
        class="tw-flex tw-justify-start tw-items-center tw-text-gray-700 dark:tw-text-gray-300 tw-mb-3 tw-font-medium"
        [class.text-danger]="!values?.length"
        [class.alert-danger]="!values?.length"
        [class.alert]="!values?.length"
      >
        ●
        {{ "messages.requiredMsg" | translate }}
        <i
          *ngIf="values?.length"
          class="mdi mdi-24px tw-mb-2 text-success mdi-check tw-mr-2"
        ></i>
        <i
          *ngIf="!values?.length"
          class="mdi mdi-24px tw-mb-2 text-success mdi-check tw-mr-2 opacity-0"
        ></i>
      </p>
    </ng-container>

    <!-- search box -->
    <div class="sm:tw-flex tw-justify-start">
      <div [class]="input_searchBoxGridClass">
        <mat-form-field
          class="select-list__search tw-w-full"
          appearance="outline"
        >
          <mat-label>{{ input_searchLabel | translate }}</mat-label>
          <input matInput #searchInput />
          <mat-icon class="dark:tw-text-gray-400" matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <ng-content select=".small-select" class="sm:tw-w-1/2"> </ng-content>
    </div>

    <div class="tw-flex tw-justify-between tw-mx-1">
      <!-- select all checkbox -->
      <div
        class="tw-my-3 tw-pr-0 tw-flex tw-items-center"
        [class.d-none]="!(filteredItems | async).length || !isShowSelectAll"
      >
        <div class="checkbox-section">
          <mat-checkbox
            [(ngModel)]="isSelectAll"
            (change)="selectAll()"
            class="example-margin"
          >
            {{ "common.selectAll" | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div
    [formGroup]="input_form"
    class="select-list__items tw-pl-4 tw-overflow-y-auto"
    [class]="(filteredItems | async).length ? heightClass : ''"
    [class.d-none]="loading"
  >
    <mat-selection-list
      class="row"
      [formControlName]="input_formControlName"
      [disabled]="isReadOnly"
      [class.opacity-7]="isReadOnly"
      [class]="
        filteredItemsCount > maxShowItemInDisplay
          ? this.isSmallSize
            ? 'overflow'
            : 'overflow-lg'
          : ''
      "
    >
      <div
        class="tw-tracking-normal !tw-px-1"
        [class]="input_responsiveClass"
        *ngFor="let item of filteredItems | async"
      >
        <mat-list-option
          #option
          [value]="item[optionValue]"
          (click)="onChangeSelectionList(option)"
          [selected]="isChecked(item[optionValue])"
          [disabled]="item.disabled"
          [class]="input_listOptionCustomClass"
        >
          <div
            class="tw-text-wrap tw-leading-[16px]"
            [class]="input_optionCustomClass"
            [innerHTML]="item[optionTitle]"
          ></div>
        </mat-list-option>
      </div>
    </mat-selection-list>
  </div>

  <!-- empty list -->
  <ng-container *ngIf="!(filteredItems | async).length && !loading">
    <p
      class="tw-text-gray-400 dark:tw-text-gray-200 tw-text-lg tw-text-center empty tw-tracking-normal tw-my-8"
    >
      {{ "common.empty" | translate }}
    </p>
  </ng-container>

  <!-- loading -->
  <div class="tw-flex-center tw-mt-5 select-list-loading" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only tw-tracking-normal">Loading...</span>
    </div>
    <span
      class="text-primary tw-text-lg tw-font-medium tw-mx-2 tw-tracking-normal"
      >{{ "common.loading" | translate }}</span
    >
  </div>

  <!-- footer -->
  <div class="select-list__footer" [class.d-none]="!isShowSelectAll">
    <div class="tw-flex select-list__totalcount">
      <!-- total count -->
      <div class="tw-mx-2">
        <span class="title tw-tracking-normal"
          >{{ "common.allCount" | translate }} :</span
        >
        <span class="badge badge-secondary badge-sm">{{ items?.length }}</span>
      </div>

      <!-- selected count -->
      <div class="tw-mx-2">
        <span class="title tw-tracking-normal"
          >{{ "common.chosen" | translate }} :</span
        >
        <span class="badge badge-secondary badge-sm">{{
          totalSelectedCount
        }}</span>
      </div>
    </div>
  </div>
</section>
